import React, { Component } from "react"
import { motion } from "framer-motion"

import "./hero.scss"
import ThemeContext from "shared/context"

import image1 from "shared/assets/images/test.jpg"
import image2 from "shared/assets/images/test2.jpg"
import image3 from "shared/assets/images/test3.jpg"
import image4 from "shared/assets/images/test4.jpg"
import image5 from "shared/assets/images/test5.jpg"

const images = [
  image1,
  image2,
  image3,
  image4,
  image5
]

const preloadImages = (sources, callback) => {
	let images = []
	const tryCallback = () => {
		let allImagesLoaded = (() => {
			for (var i = images.length; i--;) {
				if(!images[i].isLoaded){
					return false
				}
			}
			return true
		})()
		if (allImagesLoaded) callback()
	}
	for (let i = sources.length; i--;) {
		let image = document.createElement('img')
		images.push(image)
		image.onload = function() {
			this.isLoaded = true
			tryCallback()
		}
		image.src = sources[i]
	}
}

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      images: images,
      index: 0
    }  
  }

  componentDidMount() {
    /*preloadImages(images, () => {
      this.setState({
        loaded: true
      })
      window.setTimeout(() => {
        this.play()
      }, 2000)
    })*/
    window.setTimeout(() => {
      this.play()
    }, 2000)
  }

  play() {    
    if (!this.context.menu) {
      this.setState({
        index: (this.state.index >= 4 ? 0 : this.state.index + 1)
      })
    }
    window.setTimeout(() => {
      this.play()
    }, 2000)  
  }

  render() {
    const variants = {
      hidden: {
        scale: 1,
        transition: {
          ease: "easeInOut",
          duration: 0.5
        }
      },
      visible: {
        scale: 1.4,
        transition: {
          ease: "easeInOut",
          duration: 0.5
        }
      }
    }
    const logoVariants = {
      hidden: {
        opacity: 0
      },
      visible: {
        opacity: 1
      }
    }
    return (
      <div className="c-Hero">
        <div className="c-Hero-stage">
          <motion.div className="c-Hero-logo" animate={this.context.menu ? "hidden" : "visible"} variants={logoVariants}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165.095 194.339">
              <path fill="currentColor" d="M1.577 10.968h74.7a.872.872 0 0 0 .86-.86V.86a.872.872 0 0 0-.86-.86h-74.7a.925.925 0 0 0-.86.86v9.176a.939.939 0 0 0 .86.932zM1.577 32.836h74.7a.872.872 0 0 0 .86-.86v-9.18a.872.872 0 0 0-.86-.86h-74.7a.872.872 0 0 0-.86.86v9.176a.925.925 0 0 0 .86.864zM.717 88.462v9.176a.872.872 0 0 0 .86.86h63.8a.872.872 0 0 1 .86.86v9.176a.872.872 0 0 1-.86.86h-63.8a.872.872 0 0 0-.86.86v9.176a.872.872 0 0 0 .86.86h63.8a.872.872 0 0 1 .86.86v9.319a.872.872 0 0 1-.86.86h-63.8a.872.872 0 0 0-.86.86v9.176a.872.872 0 0 0 .86.86h63.8a.872.872 0 0 1 .86.86v9.176a.872.872 0 0 1-.86.86h-63.8a.872.872 0 0 0-.86.86v9.176a.872.872 0 0 0 .86.86h74.7a.872.872 0 0 0 .86-.86v-74.7a.872.872 0 0 0-.86-.86h-74.7a.872.872 0 0 0-.86.865zM1.577 76.633h74.7a.872.872 0 0 0 .86-.86v-9.248a.872.872 0 0 0-.86-.86h-74.7a.872.872 0 0 0-.86.86v9.176a.939.939 0 0 0 .86.932zM165.095 10.036V.86a.872.872 0 0 0-.86-.86h-74.7a.872.872 0 0 0-.86.86v52.977a.872.872 0 0 0 .86.86h63.8a.872.872 0 0 1 .86.86v9.176a.872.872 0 0 1-.86.86h-63.8a.872.872 0 0 0-.86.86v96.778a.872.872 0 0 0 .86.86h74.7a.872.872 0 0 0 .86-.86v-9.1a.872.872 0 0 0-.86-.86h-63.8a.872.872 0 0 1-.86-.86v-9.176a.872.872 0 0 1 .86-.86h63.8a.872.872 0 0 0 .86-.86v-9.176a.872.872 0 0 0-.86-.86h-63.8a.872.872 0 0 1-.86-.86v-9.176a.872.872 0 0 1 .86-.86h63.8a.872.872 0 0 0 .86-.86v-9.176a.872.872 0 0 0-.86-.86h-63.8a.872.872 0 0 1-.86-.86v-9.182a.872.872 0 0 1 .86-.86h63.8a.872.872 0 0 0 .86-.86v-9.176a.872.872 0 0 0-.86-.86h-63.8a.872.872 0 0 1-.86-.86v-9.177a.872.872 0 0 1 .86-.86h63.8a.872.872 0 0 0 .86-.86V44.661a.872.872 0 0 0-.86-.86h-63.8a.872.872 0 0 1-.86-.86v-9.248a.872.872 0 0 1 .86-.86h63.8a.872.872 0 0 0 .86-.86V22.8a.872.872 0 0 0-.86-.86h-63.8a.872.872 0 0 1-.86-.86v-9.252a.872.872 0 0 1 .86-.86h63.8a.889.889 0 0 0 .86-.932zM32.259 43.801H1.577a.872.872 0 0 0-.86.86v9.176a.872.872 0 0 0 .86.864h30.682a.872.872 0 0 0 .86-.86v-9.18a.828.828 0 0 0-.86-.86zM45.665 54.701h30.682a.872.872 0 0 0 .86-.86v-9.18a.872.872 0 0 0-.86-.86H45.665a.872.872 0 0 0-.86.86v9.176a.828.828 0 0 0 .86.864z"/>
              <g>
                <path d="M122.779 188.107c0 3.621 1.432 4.126 2.863 4.126s2.863-.505 2.863-4.126-1.431-4.126-2.863-4.126c-1.347 0-2.863.505-2.863 4.126z" fill="none"/>
                <path fill="currentColor" d="M5.389 192.487c-2.105 0-3.116-1.432-3.116-4.379s1.011-4.379 3.116-4.379a2.813 2.813 0 0 1 2.864 2.189l2.105-.674a4.812 4.812 0 0 0-4.969-3.368c-3.621 0-5.389 2.105-5.389 6.232s1.768 6.232 5.389 6.232a4.827 4.827 0 0 0 5.053-3.705l-2.189-.591a2.838 2.838 0 0 1-2.864 2.443zM18.021 182.044h2.274v12.126h-2.274zM44.295 182.044h2.274v12.126h-2.274zM31.158 194.17h2.274v-10.189h3.284v-1.937h-8.842v1.937h3.284zM57.599 192.065l5.726-9.095v-.926h-8.841v2.021h5.474l-5.727 9.179v.926h9.347v-1.937h-6.063zM72.421 189.033h5.305v-1.852h-5.305v-3.2h5.558v-1.937h-7.832v12.126h8v-1.852h-5.726zM84.716 182.044v12.126h2.274v-7.663l5.137 7.663h2.105v-12.126h-2.358v7.747l-5.053-7.747zM109.895 182.044h-2.274v12.126h7.326v-1.852h-5.053zM125.641 181.876c-3.621 0-5.389 2.021-5.389 6.232s1.684 6.232 5.389 6.232 5.389-2.021 5.389-6.232-1.683-6.232-5.389-6.232zm0 10.611c-2.105 0-3.116-1.347-3.116-4.379s.926-4.379 3.116-4.379 3.116 1.347 3.116 4.379-.926 4.379-3.116 4.379zM137.684 182.044v12.126h2.274v-7.663l5.137 7.663h2.105v-12.126h-2.274v7.747l-5.137-7.747zM158.736 189.455h3.368v.084c-.168 2.105-1.01 2.947-2.779 2.947-2.105 0-3.2-1.432-3.2-4.379 0-2.863 1.095-4.379 3.2-4.379a2.712 2.712 0 0 1 2.779 2.189l2.105-.674a4.679 4.679 0 0 0-4.883-3.367c-4.547 0-5.474 3.368-5.474 6.232 0 4.126 1.853 6.232 5.474 6.232 3.2 0 5.053-2.021 5.053-5.474v-1.348h-5.642z"/>
              </g>
            </svg>
          </motion.div>
          <div className="c-Hero-content">
            <motion.div className={`c-Hero-image${` c-Hero-image--` + this.state.index}`} initial="hidden" animate={this.context.menu ? "visible" : "hidden"} variants={variants} custom={{height: this.state.height, width: this.state.width}}></motion.div>
            <a href="https://www.bookatable.com/de/4150961/citizen-long-stuttgart" className="c-Hero-cta">Make a reservation</a>
          </div>
        </div>
      </div>
    )
  }
}

Hero.contextType = ThemeContext
export default Hero